import React, { useEffect, useState } from "react";
import { useGetMatrixInfo } from "../../../hook/request/auth";

const ElementChatPanel = () => {
  const ELEMENT_PATH = "/element/";
  const [isReady, setIsReady] = useState(false);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const getMatrixInfo = useGetMatrixInfo();

  useEffect(() => {
    const result = getMatrixInfo?.data?.data?.result;
    if (!result) return;
    const { matrixAccessToken, matrixUserId, homeServerUrl, deviceId } = result;
    window.indexedDB.deleteDatabase("matrix-js-sdk::web-sync-store");
    window.indexedDB.deleteDatabase("matrix-js-sdk::matrix-sdk-crypto");
    // localStorage.setItem("cinny_sessions_0", JSON.stringify(cinnySession));
    localStorage.setItem("mx_access_token", matrixAccessToken);
    localStorage.setItem("mx_device_id", deviceId);
    localStorage.setItem("mx_hs_url", homeServerUrl);
    localStorage.setItem("mx_user_id", matrixUserId);
    localStorage.setItem("mx_is_guest", "false");
    setIsReady(true);
    // console.log("MATRIX_01", result);
  }, [getMatrixInfo?.data]);

  return (
    <div
      style={{
        width: "100%",
        height: "calc(100vh - 60px)",
        overflow: "hidden",
        position: "relative", // Needed to overlay the spinner perfectly
        backgroundColor: "#f5f5f5", // Avoids stark white flashes
      }}
    >
      {/* 1. Loading Overlay: Displayed while authentication fetches OR while iframe downloads */}
      {(!isReady || !isIframeLoaded) && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#ffffff",
            zIndex: 10,
            fontFamily: "Tahoma, Vazir, sans-serif",
            direction: "rtl",
          }}
        >
          {/* Circular CSS Spinner */}
          <div
            className="spinner"
            style={{
              width: "50px",
              height: "50px",
              border: "5px solid #e0e0e0",
              borderTop: "5px solid #0ebd8f" /* Element Green Accent */,
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              marginBottom: "20px",
            }}
          />
          <div style={{ color: "#333", fontSize: "16px", fontWeight: "bold" }}>
            در حال بارگذاری صفحه گفتگوها...
          </div>
          <div style={{ color: "#777", fontSize: "12px", marginTop: "8px" }}>
            لطفاً چند لحظه منتظر بمانید
          </div>
        </div>
      )}

      {/* Inject Keyframe Animation directly into the component */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      {/* 2. Chat Iframe Container */}
      {isReady && (
        <iframe
          key="element-iframe"
          src={ELEMENT_PATH}
          title="Chat Panel"
          width="100%"
          height="90%" // Changed to 100% to fill space properly
          style={{
            border: "none",
            opacity: isIframeLoaded ? 1 : 0, // Keeps it hidden until ready
            transition: "opacity 0.3s ease-in-out", // Clean fade-in effect
          }}
          onLoad={() => setIsIframeLoaded(true)} // Fires when DOM and assets are fully pulled
          allow="camera; microphone; clipboard-read; clipboard-write; display-capture; autoplay; speaker-selection; encrypted-media;"
          allowFullScreen
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-modals allow-downloads"
        />
      )}
    </div>
  );
  //   return (
  //     <div
  //       style={{
  //         width: "100%",
  //         height: "calc(100vh - 60px)",
  //         overflow: "hidden",
  //       }}
  //     >
  //       {isReady ? (
  //         <iframe
  //           key="element-iframe" // Essential for forcing reload
  //           src={ELEMENT_PATH}
  //           title="Chat Panel"
  //           width="100%"
  //           height="90%"
  //           style={{ border: "none" }}
  //           allow="camera; microphone; clipboard-read; clipboard-write; display-capture; autoplay; speaker-selection; encrypted-media;"
  //           allowFullScreen
  //           sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-modals allow-downloads"
  //         />
  //       ) : (
  //         <div>در حال بارگذاری صفحه گفتگوها...</div>
  //       )}
  //     </div>
  //   );
};
export default ElementChatPanel;
